import { CheckCircle } from '@mui/icons-material'
import { Box, CardContent, CardMedia, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { demoProfilePicture } from '../utils/constants'

const ChannelCard = ({ channelDetail, marginTop }) => {
    // console.log(channelDetail.statistics.subscriberCount)
  return (
    <Box 
        sx={{ 
            boxShadow: 'none',
            borderRadius: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: {xs: '358px', md: '312px'},
            height: '280px',
            margin: 'auto',
            marginTop
        }}   
    >
        <Link to={`/channel/${channelDetail?.id?.channelId}`}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', color: 'fff' }}>
                <CardMedia 
                    image={channelDetail?.snippet?.thumbnails?.high?.url || demoProfilePicture}
                    alt={channelDetail?.snippet?.title}
                    sx={{ borderRadius: '50%', height: '180px', width: '180px', mb: 2 , border: '1ps solid #e3e3e3'}}
                />
                <Typography variant='h6' sx={{ color: '#fff' }}>
                    {channelDetail?.snippet?.title}
                    <CheckCircle sx={{ fontSize: 14, color: 'gray', ml: '5px' }} />
                </Typography>

                {channelDetail?.statistics?.subscriberCount && (
                    <Typography color='gray'>
                        {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString()} Subscribers 
                    </Typography>
                )}


            </CardContent>
        </Link>

    </Box>
  )
}

export default ChannelCard